import { get } from '../utils';
import { AsyncStatus } from './constants';
export var getAsyncState = function (key) {
    var initialState = {
        status: AsyncStatus.INITIAL,
    };
    return function (state, idx) {
        var path = idx !== undefined ? [key, idx] : [key];
        return get(state.async, path) || initialState;
    };
};
